// extracted by mini-css-extract-plugin
export var container = "LocaleDialogAreaMenu-module--container--45b1d";
export var locales = "LocaleDialogAreaMenu-module--locales--bd448";